import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentPortfolioVisibilityFilter } from '../Portfolio/selectors';
import { currentUserSelector } from '../Users/selectors';
import { selectCurrentCoursePathState } from './CurrentCoursePath/selectors';
import { selectCurrentCoursePath } from './derived-selectors';

export { selectCurrentCoursePath };
export const coursesSelector = (state) => state.Courses;

export const selectCurrentCourseCode = createSelector(
  [selectCurrentCoursePathState],
  (currentCoursePathState) => {
    const courseCode = currentCoursePathState.get('courseCode');
    const coursePath = currentCoursePathState.get('coursePath');
    if (courseCode) {
      return courseCode;
    } else if (coursePath) {
      return `/${coursePath}`.split('/courses/')[1];
    } else {
      return null;
    }
  }
);

export const currentCourseSelector = createSelector(
  coursesSelector,
  selectCurrentCoursePath,
  (courses, currentCourse) => {
    if (courses.has(currentCourse)) {
      return courses.get(currentCourse);
    }
    return null;
  }
);

export const currentCourseOutcomesSelector = createSelector(
  currentCourseSelector,
  (course) => {
    let outcomes = course ? course.get('outcomes') : null;
    if (outcomes) {
      outcomes = outcomes.filter((outcome) => !outcome.get('isDeleted'));
    }
    return outcomes;
  }
);

export const selectCurrentCourseIsOffline = createSelector(
  currentCourseSelector,
  (course) => {
    return course ? course.get('isOffline') : true;
  }
);

export const currentCourseObjectiveSelector = createSelector(
  currentCourseSelector,
  (course) => {
    return course ? course.get('objective') : null;
  }
);

export const selectIsAdminOfCurrentCourse = createSelector(
  currentCourseSelector,
  currentUserSelector,
  (currentCourse, currentUser) => {
    if (!currentCourse || !currentUser) {
      return false;
    }
    return (
      currentCourse.get('admins').indexOf(currentUser.get('profileName')) !== -1
    );
  }
);

export const selectCoursesForPortfolioByVisibilityFilter = createSelector(
  coursesSelector,
  selectCurrentPortfolioVisibilityFilter,
  (courses, visibilityFilter) => {
    let visibility = Immutable.List();

    if (visibilityFilter === 'all') {
      visibility = Immutable.List(['show', 'hide']);
    } else {
      visibility = Immutable.List([visibilityFilter]);
    }

    const hasRightVisibilityFilter = (course) => {
      if (course.get('visibility')) {
        const testVisiblity = visibility.filter((visibilityType) =>
          course.get('visibility').includes(visibilityType)
        );
        return testVisiblity.size > 0;
      } else {
        return false;
      }
    };

    return courses
      .filter((course) => hasRightVisibilityFilter(course))
      .toList();
  }
);

export const isCurrentCourseRTLSelector = createSelector(
  currentCourseSelector,
  (currentCourse) => {
    if (!currentCourse) {
      return false;
    }

    return currentCourse.get('isRightToLeft', false);
  }
);

export const selectIsInCourse = createSelector(
  selectCurrentCoursePathState,
  (coursePathStore) =>
    !!(coursePathStore.get('coursePath') || coursePathStore.get('courseCode'))
);

export const currentCourseInstitutionSelector = createSelector(
  currentCourseSelector,
  (course) => {
    return course ? course.get('institution') : null;
  }
);
